// src/tenantAdmin/pages/TenantPersonasPage.jsx
// Tenant-admin console → Personas. Route /tenant-admin/personas.
//
// `isTenantAdmin` is true for a real user_tenants admin row AND for the admin of
// the customer that owns this tenant, which is exactly the two roles the work
// item names ("Customer-Admin e Tenant-admin") — so no extra gate is needed here.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext.jsx';
import PersonasView from '../../context/PersonasView.jsx';
import SectionCard, { PAGE_COLUMN, CARD_BODY } from '../../components/ui/SectionCard.jsx';
import PageBand from '../../components/ui/PageBand.jsx';
import PersonalizationBadge from '../../onboarding/ui/PersonalizationBadge.jsx';


// The card is the page's ONLY section, so it carries no header of its own (the band names the page): the body
// pads all four sides itself.
const CARD_BODY_ALONE = { ...CARD_BODY, paddingTop: '24px' };

export default function TenantPersonasPage() {
  const { t } = useTranslation('admin');
  const { activeTenant, isTenantAdmin, user } = useAuth();
  return (
    // The console's white band carries the page's <h1> (+ the personalization badge); the section card below
    // has no header — it is the page's only section. v197: `assist` turns on the persona AI aids here and ONLY
    // here (the superadmin mount never passes it).
    <div>
      <PageBand
        title={t('personas.title')}
        aside={<PersonalizationBadge />}
        // v201: no workspace name in the subtitle.
        subtitle={t('personas.subtitle')}
      />
      <div style={PAGE_COLUMN}>
        <SectionCard>
          <div style={CARD_BODY_ALONE}>
            <PersonasView
              tenantId={activeTenant?.tenant_id} canWrite={isTenantAdmin} assist
              userKey={user?.user_id || user?.email || ''}
            />
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
